export default __webpack_public_path__ + "static/media/50t.386cc0ff.jpg";